import { DateUtilities } from "@/@core/utilities/DateUtilities";
import { DcmDocumentListConfig, DcmDocumentListQuery } from "@/@modules/dcm/interfaces/DcmDocumentListConfiguration";

export class DcmConfigService {
  public static getAgentConfigForSignatureList(vue: any): DcmDocumentListConfig<DcmDocumentListQuery> {
    return {
      title: "",
      itemKey: "C.cmis:objectId",
      itemName: "C.dcm:name",
      limit: {
        default: 10,
        options: [10, 20, 50],
      },
      query: {
        select: [{ value: "C.*" }],
        from: { value: "dcm:citizen", as: "C" },
        where: [
          { key: "C.dcm:status", operator: "IN", value: ["to qualify", "qualified"] },
          { key: "C.dcm:type", operator: "=", value: ["signatureRequest"] },
        ],
        orderBy: [{ value: "C.cmis:creationDate", desc: true }],
        limit: 10,
        offset: 0,
      },
      columns: [
        {
          key: "C.cmis:creationDate",
          label: "fseg.dcm.date",
          class: "secondary--text title creationDate",
          pipe: item => {
            return DateUtilities.formatWithTime(item["C.cmis:creationDate"]);
          },
        },
        {
          key: "C.cmis:description",
          label: "fseg.dcm.description",
          class: "secondary--text title description",
          pipe: item => {
            return `${vue.$tc(`fseg.dcm.signature.${item["C.cmis:description"].split(";")[0]}`)} ${
              JSON.parse(item["C.cmis:description"].split(";")[1]).Iban
            }`;
          },
        },
        {
          // TODO?: format ssin
          key: "C.dcm:ssin",
          label: "fseg.dcm.ssin",
          class: "secondary--text title ssin",
        },
        {
          key: "C.dcm:status",
          label: "fseg.dcm.status",
          class: "secondary--text title status",
          pipe: item => {
            return vue.$tc(
              `fseg.dcm.signature.${
                item["C.dcm:refId"] != null && item["C.dcm:status"] == "qualified"
                  ? "signed"
                  : item["C.dcm:refId"] != null && item["C.dcm:status"] == "to qualify"
                  ? "updateError"
                  : item["C.dcm:refId"] == null && item["C.dcm:status"] == "qualified"
                  ? "error"
                  : "unsigned"
              }`
            );
          },
        },
        {
          key: "data-table-expand",
          label: "",
        },
      ],
      filters: [
        {
          key: "C.dcm:ssin",
          label: "fseg.dcm.ssin",
          operator: "=",
          rules: [(ssin: string) => (ssin ? (vue.validateSsin(ssin) ? true : vue.$tc("format.ssin.error")) : true)],
          title: "fseg.dcm.ssin",
          type: "ssin",
        },
        {
          key: "C.dcm:status",
          label: "fseg.dcm.status",
          operator: "IN",
          options: [
            { label: "fseg.dcm.toQualify", value: "to qualify" },
            { label: "fseg.dcm.qualified", value: "qualified" },
          ],
          title: "fseg.dcm.status",
          type: "checkbox",
        },
      ],
    };
  }

  public static getWorkerConfigForSignatureList(vue: any): DcmDocumentListConfig<DcmDocumentListQuery> {
    return {
      title: "",
      itemKey: "C.cmis:objectId",
      itemName: "C.dcm:name",
      limit: {
        default: 10,
        options: [10, 20, 50],
      },
      query: {
        select: [{ value: "C.*" }],
        from: { value: "dcm:citizen", as: "C" },
        where: [
          { key: "C.dcm:type", operator: "=", value: ["signatureRequest"] },
          { key: "C.dcm:status", operator: "=", value: ["qualified"] },
          { key: "C.dcm:refId", operator: "IS", value: "NOT NULL" },
        ],
        orderBy: [{ value: "C.cmis:creationDate", desc: true }],
        limit: 10,
        offset: 0,
      },
      columns: [
        {
          key: "C.cmis:creationDate",
          label: "fseg.dcm.date",
          class: "secondary--text title creationDate",
          pipe: item => {
            return DateUtilities.formatWithTime(item["C.cmis:creationDate"]);
          },
        },
        {
          key: "C.cmis:description",
          label: "fseg.dcm.description",
          class: "secondary--text title description",
          pipe: item => {
            return `${vue.$tc(`fseg.dcm.signature.${item["C.cmis:description"].split(";")[0]}`)} ${
              JSON.parse(item["C.cmis:description"].split(";")[1]).Iban
            }`;
          },
        },
        {
          key: "C.dcm:status",
          label: "fseg.dcm.status",
          class: "secondary--text title status",
          pipe: item => {
            return vue.$tc(
              `fseg.dcm.signature.${
                item["C.dcm:refId"] != null && item["C.dcm:status"] == "qualified"
                  ? "signed"
                  : item["C.dcm:refId"] != null && item["C.dcm:status"] == "to qualify"
                  ? "updateError"
                  : item["C.dcm:refId"] == null && item["C.dcm:status"] == "qualified"
                  ? "error"
                  : "unsigned"
              }`
            );
          },
        },
        {
          key: "data-table-expand",
          label: "",
        },
      ],
    };
  }

  public static getConfigForSignatureDetails(item: any): DcmDocumentListConfig<DcmDocumentListQuery> {
    return {
      title: "",
      itemKey: "C.cmis:objectId",
      itemName: "C.dcm:name",
      limit: {
        default: 10,
        options: [],
      },
      query: {
        select: [{ value: "C.*" }],
        from: { value: "dcm:citizen", as: "C" },
        where: [
          {
            key: "C.dcm:refId",
            operator: "=",
            value: item["C.cmis:objectId"].split(";")[0],
          },
        ],
        orderBy: [{ value: "C.cmis:creationDate", desc: true }],
        limit: 10,
        offset: 0,
      },
      columns: [
        {
          key: "C.dcm:type",
          label: "fseg.dcm.type",
        },
        {
          key: "C.dcm:name",
          label: "fseg.dcm.fileName",
        },
      ],
      actions: {
        download: {
          label: "dcm.download",
          icon: "fa fa-download",
          isDisabled: () => false,
        },
      },
    };
  }
}
